import React from "react";
import PropTypes from "prop-types";
import PoolDataContext from "./pool-data-context";
import moment from "moment";
import { FISCAL_YEAR } from "../utils/constants";

const getDaysUntil = end => {
  const end_moment = moment(end);
  const start = moment();

  const diff = end_moment.diff(start, "days") + 1;
  return Math.sign(diff) === -1 ? 0 : diff;
};

const DATE_FORMAT = "YYYY-MM-DD";

const usePoolDataResolver = (poolId, orgFiscalYearEnd) => {
  const {
    settings,
    goals,
    fetchGoalsIfNotCached,
    fetchSettingsIfNotCached,
    fetchSettings,
    fetchGoals,
  } = React.useContext(PoolDataContext);

  const goals_for_pool = goals[poolId] || {};
  const settings_for_pool = settings[poolId] || {};

  React.useEffect(() => {
    if (poolId) {
      fetchGoalsIfNotCached(poolId);
      fetchSettingsIfNotCached(poolId);
    }
  }, [fetchGoalsIfNotCached, fetchSettingsIfNotCached, poolId]);

  const { duration_type = FISCAL_YEAR } = settings_for_pool;
  const days_left = duration_type === "CUSTOM" ? getDaysUntil(settings.end_date) : getDaysUntil(orgFiscalYearEnd);

  const activity_date_parameters =
    duration_type === "CUSTOM"
      ? {
          gte: moment(settings_for_pool.start_date).format(DATE_FORMAT),
          lte: moment(settings_for_pool.end_date).format(DATE_FORMAT),
        }
      : {
          lte: orgFiscalYearEnd,
          gte: moment(orgFiscalYearEnd)
            .subtract(1, "year")
            .format(DATE_FORMAT),
        };

  return {
    goals: goals_for_pool,
    settings: settings_for_pool,
    fetchSettings,
    fetchGoals,
    activityDateParameters: activity_date_parameters,
    daysLeft: days_left,
  };
};

const usePoolDataResolverMultiple = (poolIds = []) => {
  const { settings, goals, fetchGoalsIfNotCached, fetchSettingsIfNotCached } = React.useContext(PoolDataContext);

  React.useEffect(() => {
    poolIds.forEach(id => {
      fetchGoalsIfNotCached(id);
      fetchSettingsIfNotCached(id);
    });
  }, [fetchGoalsIfNotCached, fetchSettingsIfNotCached, poolIds]);

  return { settings, goals };
};

// Deprecated
const PoolDataResolver = ({ poolId, render, orgFiscalYearEnd, ...props }) => {
  const poolData = usePoolDataResolver(poolId, orgFiscalYearEnd);
  return render(poolData);
};

PoolDataResolver.propTypes = {
  poolId: PropTypes.number,
  render: PropTypes.func,
};

export { usePoolDataResolver, usePoolDataResolverMultiple };

export default PoolDataResolver;
